import { ArrowRightIcon, ArrowsLeftRightIcon, ArrowSquareOutIcon, ArrowUDownLeftIcon } from '@phosphor-icons/react'

import { outboundExchangeKey, parcelTypes } from '@/parcels/constants'

export const parcelTypeChip = {
  [parcelTypes.outbound]: {
    label: 'Envío de pedido',
    Icon: ArrowRightIcon,
  },
  [outboundExchangeKey]: {
    label: 'Envío de cambio',
    Icon: ArrowsLeftRightIcon,
  },
  [parcelTypes.inbound]: {
    label: 'Envío de devolución',
    Icon: ArrowUDownLeftIcon,
  },
  [parcelTypes.tracking]: {
    label: 'Envío externo',
    Icon: ArrowSquareOutIcon,
  },
}
